@switch (searchType) {
  @case ('default') {
    <label class="search-box">
      <app-icon style="color: lightgrey">search</app-icon>
      <input
        #inputRef
        placeholder="{{ 'search' | translate }}..."
        autocomplete="off"
        class="{{ customClass }}"
        [ngClass]="{ 'disabled-input': disabled }"
        [(ngModel)]="input"
        [disabled]="disabled"
        (ngModelChange)="onchange($event)"
      />
      <app-icon style="color: black" [ngClass]="{ visible: input, hidden: !input }" class="click-css" (click)="clear()"
        >close</app-icon
      >
    </label>
  }
  @case ('cancel') {
    <label class="search-box">
      <app-icon style="color: lightgrey">search</app-icon>
      <input
        #inputRef
        placeholder="{{ 'search' | translate }}..."
        autocomplete="off"
        class="{{ customClass }}"
        [ngClass]="{ 'disabled-input': disabled }"
        [(ngModel)]="input"
        [disabled]="disabled"
        (ngModelChange)="onchange($event)"
      />
      <app-icon style="color: black" [ngClass]="{ visible: input, hidden: !input }" class="click-css" (click)="clear()"
        >close</app-icon
      >
    </label>
  }
  @case ('transparent') {
    <label class="search-box search-transparent">
      <app-icon style="color: lightgrey">search</app-icon>
      <input
        #inputRef
        placeholder="{{ 'search' | translate }}..."
        autocomplete="off"
        class="{{ customClass }}"
        [ngClass]="{ 'disabled-input': disabled }"
        [(ngModel)]="input"
        [disabled]="disabled"
        (ngModelChange)="onchange($event)"
      />
      <app-icon style="color: white" [ngClass]="{ visible: input, hidden: !input }" class="click-css" (click)="clear()"
        >close</app-icon
      >
    </label>
  }
  @case ('chats') {
    <div class="search-box search-chats" (mousedown)="keepFocus($event)">
      @if (!loading) {
        <app-icon class="search-icon"> search </app-icon>
      }
      @if (loading) {
        <app-loader class="loader" size="tiny" />
      }
      <input
        #inputRef
        placeholder="{{ 'search' | translate }}..."
        autocomplete="off"
        class="{{ customClass }}"
        [ngClass]="{ 'disabled-input': disabled }"
        [(ngModel)]="input"
        [disabled]="disabled"
        (ngModelChange)="onchange($event)"
        (mousedown)="$event.stopPropagation()"
      />
      @if (arrows) {
        <div class="arrows">
          <app-icon class="icon-button click-css" matRipple (mousedown)="arrowUpClick($event)"
            >keyboard_arrow_up</app-icon
          >
          <app-icon class="icon-button click-css" matRipple (mousedown)="arrowDownClick($event)"
            >keyboard_arrow_down</app-icon
          >
        </div>
      }
      @if (input || clearVisibility) {
        <app-icon class="icon-button click-css" matRipple (mousedown)="clear()">close</app-icon>
      }
    </div>
  }
}
